// @flow

import type { Merchant } from '../types';
import { getMerchantConfig } from '../get-merchant-config';

export function shouldDisableAddressAndPhone(merchant: Merchant): boolean {
  const merchantConfig = getMerchantConfig(merchant);

  return merchantConfig
    ? Boolean(merchantConfig.disable_customer_address_and_phone)
    : false;
}
